import { ServerSetting } from '../configuration/server-setting.interface';
import { MainMenu } from '../menu/menu-item.interface';
import { NotificationData } from '../notifications/notification.interface';
import { UserNotification } from '../notifications/user-notification.interface';

/**
 * Type of the message thats send to or received from the child app in the iframe
 */

export enum MessageType {
	stateChange = 'stateChange',
	navTo = 'nav',
	ready = 'ready',
	states = 'states',
	getStates = 'getStates',
	topNav = 'topNav',
	sideMenu = 'sideMenu',
	swal = 'swal',
	cache = 'cache',
	requestUserSession = 'requestUserSession',
	userSession = 'userSession',
	modalOpen = 'modalOpen',
	modalClose = 'modalClose',
	clearMenu = 'clearMenu',
	topBarRemoveButton = 'topBar.removeButton',
	updateUrl = 'updateUrl',
	notification = 'notification',
	notificationClick = 'notificationClick',
	keydown = 'keydown',
	copyToClipboard = 'copyToClipboard',
	setMenu = 'setMenu',
	setMenuVisibility = 'setMenuVisibility',
	toggleMenuVisibility = 'toggleMenuVisibility',
}

export interface IFrameMessages {
	[MessageType.navTo]: {
		url: string;
	};
	[MessageType.userSession]: {
		reportingBackend: ServerSetting;
	};
	[MessageType.clearMenu]: {
		parentMenuId: string;
	};
	[MessageType.requestUserSession]: undefined;
	[MessageType.topNav]: {
		action: string;
		button?: any;
		id?: any;
	};
	[MessageType.topBarRemoveButton]: {
		id: string;
	};
	[MessageType.modalOpen]: undefined;
	[MessageType.modalClose]: undefined;
	[MessageType.sideMenu]: any;
	[MessageType.updateUrl]: {
		url: string;
	};
	[MessageType.swal]: any;
	[MessageType.notification]: any;
	[MessageType.keydown]: {
		key: string;
		ctrlKey: boolean;
		shiftKey: boolean;
		altKey: boolean;
	};
	[MessageType.notificationClick]: UserNotification<NotificationData>;
	[MessageType.copyToClipboard]: {
		data: any;
	};
	[MessageType.setMenu]: {
		menu: MainMenu;
	};
	[MessageType.setMenuVisibility]: {
		isVisible: boolean;
	};
	[MessageType.toggleMenuVisibility]: undefined;
}
